"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var base_1 = __importDefault(require("@emotion/styled/base"));
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var gatsby_1 = require("gatsby");
var react_1 = require("@emotion/react");
var StyledNameBarFixed = base_1.default("div", {
    target: "e1f96pra0",
    label: "StyledNameBarFixed"
})(process.env.NODE_ENV === "production" ? {
    name: "o1th59",
    styles: "width:100%;position:fixed;padding:var(--gutter-small) 0;background:#fff;a{color:inherit;}"
} : {
    name: "o1th59",
    styles: "width:100%;position:fixed;padding:var(--gutter-small) 0;background:#fff;a{color:inherit;}",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9vcHQvYnVpbGQvcmVwby9zcmMvY29tcG9uZW50cy9OYW1lQmFyRml4ZWQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUlxQyIsImZpbGUiOiIvb3B0L2J1aWxkL3JlcG8vc3JjL2NvbXBvbmVudHMvTmFtZUJhckZpeGVkLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IExpbmsgfSBmcm9tICdnYXRzYnknXG5pbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnXG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcblxuY29uc3QgU3R5bGVkTmFtZUJhckZpeGVkID0gc3R5bGVkLmRpdmBcbiAgICB3aWR0aDogMTAwJTtcbiAgICBwb3NpdGlvbjogZml4ZWQ7XG4gICAgcGFkZGluZzogdmFyKC0tZ3V0dGVyLXNtYWxsKSAwO1xuICAgIGJhY2tncm91bmQ6ICNmZmY7XG5cbiAgICBhIHtcbiAgICAgICAgY29sb3I6IGluaGVyaXQ7XG4gICAgfVxuYFxuXG5jb25zdCBOYW1lQmFyRml4ZWQgPSAoKSA9PiAoXG4gICAgPFN0eWxlZE5hbWVCYXJGaXhlZD5cbiAgICAgICAgPGRpdiBjbGFzc05hbWU9XCJyb3dcIj5cbiAgICAgICAgICAgIDxMaW5rIHRvPVwiL1wiPkpvc2VmIERhYmVybmlnPC9MaW5rPlxuICAgICAgICA8L2Rpdj4gXG4gICAgPC9TdHlsZWROYW1lQmFyRml4ZWQ+XG4pXG5cbmV4cG9ydCBkZWZhdWx0IE5hbWVCYXJGaXhlZFxuIl19 */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var NameBarFixed = function NameBarFixed() {
    return react_1.jsx(StyledNameBarFixed, null, react_1.jsx("div", {
        className: "row"
    }, react_1.jsx(gatsby_1.Link, {
        to: "/"
    }, "Josef Dabernig")));
};
exports.default = NameBarFixed;
